import { url } from "../../static/env";
import { fetchJsonWithRetry } from "../../utils/fetchWithRetry";
// const url = process.env.REACT_APP_API_URL;

export function getChats(pars, callback) {
    fetch(url + '/getchats', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(pars)
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}

/**
 * @param {number|string} user_id — id собеседника в чате (как раньше)
 * @param {{ messages_fast?: boolean, chat_id?: number|string }} [options]
 */
export function getMessages(user_id, options = {}) {
    console.log('getMessages', user_id, options)
    const body = { user_id };
    if (options.messages_fast) {
        body.messages_fast = '1';
    }
    if (options.chat_id) {
        body.chat_id = options.chat_id;
    }
    const { onRetryProgress } = options;
    return fetchJsonWithRetry(
        url + '/messages',
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        },
        { onRetryProgress }
    )
      .then(({ data }) => {
        console.log(data);
        return data.messages;
      })
      .catch(error => {
        console.error('Error fetching messages:', error);
        throw error;
      });
  }

/** Догрузка is_viewed / view_status после messages_fast (как десктоп /messages/view-meta) */
export async function getMessagesViewMeta(user_id, message_ids, buh_id = 0) {
    const response = await fetch(url + '/messages/view-meta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            user_id,
            buh_id: buh_id || 0,
            message_ids,
        }),
    });
    if (!response.ok) {
        throw new Error(`view-meta HTTP ${response.status}`);
    }
    const data = await response.json();
    return data.view_meta || [];
}

export function getUnreadMessagesCount(user_id) {
    return fetch(url + '/messages-unread-count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_id }),
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Error fetching unread messages count:', error);
        throw error;
      });
}

export function markCompanyChatUnread(user_id) {
    return fetch(url + '/company-chat/mark-unread', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id }),
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error markCompanyChatUnread:', error);
            throw error;
        });
}

export function markCompanyChatRead(user_id) {
    return fetch(url + '/company-chat/mark-read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id }),
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error markCompanyChatRead:', error);
            throw error;
        });
}

/** Пометить входящие сообщения клиента прочитанными (как в мобилке). */
export function markClientMessagesRead(user_id, options = {}) {
    const body = { user_id };
    if (options.chat_id) body.chat_id = options.chat_id;
    return fetch(url + '/mark-client-messages-read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error markClientMessagesRead:', error);
            throw error;
        });
}

export async function getMessages20(pars) {
    try {
        const response = await fetch(url + '/getmessages20', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(pars)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching messages:', error);
        throw error;
    }
}

export function getAllMessages(callback) {
    fetch(url + '/getallmessages', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}

export function editMessage(message_id, text) {
  return fetch(url + "/editmessage", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ message_id, text }),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error("Error editMessage:", error);
      throw error;
    });
}

export function delMessage(message_id) {
  return fetch(url + "/delmessage", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ message_id }),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error("Error delMessage:", error);
      throw error;
    });
}

export function sendMessage(pars, callback) {
    fetch(url + '/sendmessage', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(pars)
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}

/** Отправка текста (fallback, если сокет недоступен). */
export async function sendMessageHttp({ from_id, text, to_id, reply_id = 0, chat_id = null, author_user_id = null }) {
    const body = { from_id, text, to_id, reply_id: reply_id || 0 };
    if (chat_id) body.chat_id = chat_id;
    if (author_user_id) body.author_user_id = author_user_id;
    console.log('[sendMessageHttp] POST /sendmessage', {
        from_id,
        to_id,
        chat_id: chat_id || null,
        text_len: String(text || '').length,
        reply_id: body.reply_id,
    });
    const response = await fetch(url + '/sendmessage', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        console.error('[sendMessageHttp] fail', response.status, data);
        throw new Error(data.error || `HTTP ${response.status}`);
    }
    console.log('[sendMessageHttp] ok', data);
    return data;
}

export function sendMessageWA(pars, callback) {
    fetch(url + '/sendmessagewa', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(pars)
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}

export function sendMessageFile(pars, callback) {
    let formData = new FormData();
    formData.append('message_file', pars.upload_file);
    formData.append('chat_id', pars.chat_id);
    formData.append('user_id', pars.user_id);

    fetch(url + '/sendmessagefile', {
        method: 'POST',
        body: formData
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}

export function sendMessageTest(pars) {
    fetch(url + '/sendmessagetest', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(pars)
    })
        .then((response) => response.json())
        .then((data) => {
            // No callback provided
        });
}

export function sendLogin(pars, callback) {
    fetch(url + '/login', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(pars)
    })
        .then((response) => response.json())
        .then((data) => {
            return callback(data);
        });
}


//new
export function addFileMessage(pars, callback) {
  const formData = new FormData();

  // добавляем все файлы
  if (pars.files && pars.files.length > 0) {
    for (let i = 0; i < pars.files.length; i++) {
      const file = pars.files[i];
      // Явно указываем имя файла для сохранения правильной кодировки кириллицы
      const fileName = file.name || file.filename || `file_${i}`;
      formData.append('files[]', file, fileName);
    }
  }

  // добавляем остальные поля
  formData.append('user_id', pars.userId);
  formData.append('to_id', pars.toId);
  formData.append('text', pars.text || '');
  if (pars.replyId) formData.append('reply_id', pars.replyId);
  if (pars.chatId) formData.append('chat_id', pars.chatId);
  if (pars.authorUserId) formData.append('author_user_id', pars.authorUserId);

  fetch(url + '/upload', {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.error('Error uploading files:', error);
    });
}

